import React from "react";
import "./Login.css";
import Signup from "../components/Signup";

export default function SignupPage() {
  return(
    <Signup/>
  );
}